import Action from '../base/action';
import MenuHelper from './menuHelper';

class UpdateMenuAction extends Action {
    menuItems;
    restrictions;

    constructor(props) {
        super(props);
        this.menuItems = props.menuItems || [];
        this.restrictions = props.restrictions || [];
        this._previousMenuItemData = [];
    }

    async execute() {
        this._previousMenuItemData = MenuHelper.saveMenuItem(this.menuItems);
        MenuHelper.updateMenuItem(this.menuItems);
        MenuHelper.enableRestriction(this.restrictions)
    }

    async stop() {
        MenuHelper.updateMenuItem(this._previousMenuItemData);
        MenuHelper.removeRestriction(this.restrictions);
    }
}

export default UpdateMenuAction;
